import {Size} from '@jetbrains/ring-ui/components/input/input'
import Select from '@jetbrains/ring-ui/components/select/select'
import React, {forwardRef} from 'react'

import useEscapeSelectHidePopup from '../../hooks/useEscapeSelectHidePopup'
import styles from '../../MatrixParamBuild.css'
import type {SelectItemMatrixParameter} from '../../MatrixParamBuild.types'

import type {MatrixParamBuildParameterSelectProps} from './MatrixParamBuildParameterSelect.types'
import useMatrixParamBuildParameterSelect from './useMatrixParamBuildParameterSelect'

const MatrixParamBuildParameterSelect = forwardRef<
  HTMLInputElement,
  MatrixParamBuildParameterSelectProps
>(function MatrixParamBuildParameterSelect(
  {index, isDuplicate, options, disabled, value, hint},
  ref,
) {
  const {errorMessage, selectOptions, selectChangeHandler} = useMatrixParamBuildParameterSelect(
    index,
    options,
    isDuplicate,
    value,
  )
  const {pressedEscapePopupStyle, selectKeyDownHandler} = useEscapeSelectHidePopup()

  return (
    <div className={styles.selectRow}>
      <Select<SelectItemMatrixParameter>
        type={Select.Type.INPUT}
        size={Size.FULL}
        disabled={disabled}
        inputPlaceholder={'Enter or select parameter name'}
        data={selectOptions}
        onChange={selectChangeHandler}
        filter={{
          value,
          fn: () => true,
        }}
        onKeyDown={selectKeyDownHandler}
        popupStyle={pressedEscapePopupStyle}
        error={errorMessage}
        filterRef={ref}
        notFoundMessage={''}
        className={styles.selectLabelContainer}
        popupClassName={styles.popup}
        label={'Parameter name'}
        hideArrow
        allowAny
        clear
      />
      {hint && <div className={styles.hint}>{hint}</div>}
    </div>
  )
})

export default MatrixParamBuildParameterSelect
